import { render, staticRenderFns } from "./ReserveOrderList.vue?vue&type=template&id=38541146&"
import script from "./ReserveOrderList.vue?vue&type=script&lang=js&"
export * from "./ReserveOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports